import {
  faGithub,
  faFacebookF,
  faLinkedinIn,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

const data = [
  {
    link: 'https://github.com/HPicatto',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.facebook.com/andres.piccatto/',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.linkedin.com/in/hernan-picatto/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://twitter.com/AndBarreiro',
    label: 'Twitter',
    icon: faXTwitter,
  },
  {
    link: 'mailto:h.picatto@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
